import React from 'react'
import {
  Box,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@mui/material'

function TableLoader ({
  columns = 8,
  showHeaderButtons = true,
  headerButtonsCount = 3,
  showTitle = true,
  rows = 10,
  showPagination = true,
  tabs = false,
  tabsCount = 3
}) {
  return (
    <Box sx={{ width: '100%', overflow: 'hidden', px: 1 }}>
      {(showTitle || showHeaderButtons) && (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
          {showTitle && <Skeleton variant='text' width={180} height={30} />}

          {showHeaderButtons && (
            <Box sx={{ display: 'flex', gap: 1 }}>
              {Array.from({ length: headerButtonsCount }).map((_, index) => (
                <Skeleton
                  key={index}
                  variant='rectangular'
                  width={100}
                  height={30}
                />
              ))}
            </Box>
          )}
        </Box>
      )}
      {tabs && (
        <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
          {Array.from({ length: tabsCount }).map((_, index) => (
            <Skeleton
              key={index}
              variant='rectangular'
              width={'100%'}
              height={40}
            />
          ))}
        </Box>
      )}

      <Table size='small'>
        <TableHead>
          <TableRow>
            {Array.from({ length: columns }).map((_, colIndex) => (
              <TableCell key={`header-${colIndex}`}>
                <Skeleton variant='text' width={100} height={20} />
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <TableRow key={`row-${rowIndex}`}>
              {Array.from({ length: columns }).map((_, colIndex) => (
                <TableCell key={`cell-${rowIndex}-${colIndex}`}>
                  <Skeleton variant='text' width={100} height={16} />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {showPagination && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
          <Skeleton variant='rectangular' width={80} height={30} />
        </Box>
      )}
    </Box>
  )
}

export default TableLoader
